import React from 'react';
import AppearanceSwitch from './AppearanceSwitch';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../../contexts/LanguageContext';

const PreferencesSection = () => {
  const { t } = useTranslation('profile');
  const { language, changeLanguage, supportedLanguages } = useLanguage();

  return (
    <section className="profile-panel" aria-labelledby="profile-preferences-heading">
      <div className="profile-panel-header">
        <h2 id="profile-preferences-heading">{t('account.preferencesTitle', 'Preferences')}</h2>
      </div>

      <div className="profile-preferences-row"><div><span className="profile-preferences-label">{t('appearance.title')}</span><p className="profile-preferences-description">{t('appearance.description')}</p></div><AppearanceSwitch /></div>
      <div className="profile-preferences-row">
        <div>
          <label className="profile-preferences-label" htmlFor="profile-preferences-language">
            {t('language.title', 'Language')}
          </label>
          <p className="profile-preferences-description">
            {t('language.description', 'Choose your preferred display language.')}
          </p>
        </div>
        <select
          id="profile-preferences-language"
          className="profile-preferences-select"
          value={language}
          onChange={(event) => changeLanguage(event.target.value)}
        >
          {supportedLanguages.map((option) => (
            <option key={option.code} value={option.code}>{option.nativeName}</option>
          ))}
        </select>
      </div>
    </section>
  );
};

export default PreferencesSection;
